import { createSelector } from "reselect";
import { getIsOnDemand, shouldShowGettingStarted } from "~/store/selectors/selector.configOptions";
import { getAllFeatureFlags } from "~/store/selectors/selector.featureFlags";
import {
  canAccessMyWork,
  canAccessCalendar,
  canAccessPeopleSection,
  canAccessInvoices,
  canAccessEstimates,
  canAccessRecurringProfiles,
  canAccessCapacity,
  canAccessWorkload,
  canAccessTimesheet,
  canAccessReports,
  canAccessIntegrations,
  canAccessTrash,
  canAccessChat,
  getLoggedUser,
  isLoggedUserClientSelector,
} from "~/store/selectors/selector.users";

export const getPages = createSelector(
  canAccessMyWork,
  canAccessCalendar,
  canAccessPeopleSection,
  canAccessInvoices,
  canAccessRecurringProfiles,
  canAccessEstimates,
  canAccessCapacity,
  canAccessWorkload,
  canAccessTimesheet,
  canAccessReports,
  canAccessIntegrations,
  canAccessTrash,
  canAccessChat,
  getLoggedUser,
  getIsOnDemand,
  isLoggedUserClientSelector,
  getAllFeatureFlags,
  shouldShowGettingStarted,
  (
    myWork,
    calendar,
    people,
    invoices,
    recurring_profiles,
    estimates,
    capacity,
    workload,
    timesheet,
    reports,
    integrations,
    trash,
    chat,
    loggedUser,
    isOnDemand,
    isLoggedUserClient,
    getAllFeatureFlags,
    shouldShowGettingStarted
  ) => {
    const result = ["projects", "personal_settings"];

    if (myWork) {
      result.push("my_work");
    } else {
      result.push("my_updates");
    }

    result.push("activity");

    if (calendar) {
      result.push("calendar");
    }

    if (people) {
      result.push("people");
    }

    if (invoices) {
      result.push("invoices");
    }

    if (recurring_profiles) {
      result.push("recurring_profiles");
    }

    if (estimates) {
      result.push("estimates");
    }

    if (capacity && getAllFeatureFlags.includes("capacity")) {
      result.push("capacity");
    }

    if (workload) {
      result.push("workload");
    }

    if (timesheet) {
      result.push("timesheet");
    }

    if (reports) {
      result.push("reports");
    }

    if (integrations) {
      result.push("integrations");
    }

    if (trash) {
      result.push("trash");
    }

    if (chat) {
      result.push("chat");
    }

    if (loggedUser.class === "Owner") {
      result.push("system_settings");
      if (isOnDemand) {
        result.push("subscription");
        if (getAllFeatureFlags.includes("getting_started") && shouldShowGettingStarted) {
          result.push("getting_started");
        }
      }
      if (!isOnDemand) {
        result.push("self_hosted_settings");
      }
    }

    if (!isLoggedUserClient) {
      result.push("new_features");
    }

    if (getAllFeatureFlags.includes("whiteboards")) {
      result.push("whiteboards");
    }

    return result;
  }
);
